export default __webpack_public_path__ + "static/media/wav.9195f33f.svg";